<template>
  <div class="center-panel">
    <div class="left-top-content">
      <div class="title-pos-1">水泥工序</div>
      <div class="step-1">
        <div class="progress-wrap">
          <div class="text-number">{{snSlYlData.SNM.ts}}</div>
          <div class="text-unit">(t/h)</div>
          <div class="text-count">台产</div>
        </div>
        <div class="progress-wrap">
          <div class="text-number">{{snSlYlData.SNM.dh}}</div>
          <div class="text-unit">(kW·h/t)</div>
          <div class="text-count">电耗</div>
        </div>
        <div class="progress-wrap">
          <div class="meter">
            <meterEchart :datas="snSlYlData.SNM.eff"></meterEchart>
          </div>
          <div class="text-count" style="position: relative; top: -8px">
            运转率
          </div>
        </div>
      </div>
    </div>

    <div class="left-top-exral">
      <div class="title-pos-1">余热发电</div>
      <div class="step-1">
        <div class="progress-wrap">
          <div class="text-number">{{yrfdFdl}}</div>
          <div class="text-unit">(kW·h)</div>
          <div class="text-count">发电量</div>
        </div>
        <div class="progress-wrap">
          <div class="text-number">{{yrfdDFdl}}</div>
          <div class="text-unit">(kW·h/t)</div>
          <div class="text-count">吨熟料发电量</div>
        </div>
        <!-- <div class="progress-wrap">
                <div class="text-number">500</div>
                <div class="text-unit">(KW)</div>
                <div class="text-count">发电总功率</div>
            </div> -->
      </div>
    </div>

    <div class="left-bottom-part-2">
      <div class="title-pos-2">生料工序</div>
      <div class="step-2">
        <div class="progress-wrap">
          <div class="text-number">{{snSlYlData.SLM.ts}}</div>
          <div class="text-unit">(t/h)</div>
          <div class="text-count">台产</div>
        </div>
        <div class="progress-wrap">
          <div class="text-number">{{snSlYlData.SLM.dh}}</div>
          <div class="text-unit">(kW·h/t)</div>
          <div class="text-count">电耗</div>
        </div>
        <div class="progress-wrap">
          <div class="meter">
            <meterEchart :datas="snSlYlData.SLM.eff"></meterEchart>
          </div>
          <div class="text-count" style="position: relative; top: -8px">
            运转率
          </div>
        </div>
      </div>
    </div>

    <div class="left-center-content">
      <div class="title-pos-1">熟料工序</div>
      <div class="step-3">
        <div class="progress-wrap">
          <div class="text-number">{{snSlYlData.Y.ts}}</div>
          <div class="text-unit">(t/h)</div>
          <div class="text-count">台产</div>
        </div>
        <div class="progress-wrap">
          <div class="text-number">{{snSlYlData.Y.dh}}</div>
          <div class="text-unit">(kW·h/t)</div>
          <div class="text-count">电耗</div>
        </div>
        <div class="progress-wrap">
          <div class="meter">
            <meterEchart :datas="snSlYlData.Y.eff"></meterEchart>
          </div>
          <div class="text-count" style="position: relative; top: -8px">
            运转率
          </div>
        </div>
      </div>
    </div>
    <div class="right-bottom-content">
      <div class="title-pos-4">能耗数据</div>
      <div style="display: flex">
        <div class="text-wrap">
          <div class="text-content">
            <div class="row-2">吨熟料综合能耗</div>
            <div class="text-number-1">{{NHData.zhmh}}</div>
          </div>
          <div class="text-content">
            <div class="row-2">吨熟料实物煤耗(kg/t)</div>
            <div class="text-number-1">{{NHData.swmh}}</div>
          </div>
          <div class="text-content">
            <div class="row-2">吨熟料标准煤耗(kg/t)</div>
            <div class="text-number-1">{{NHData.bzmh}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import httpUrl from '../../../views/httpUrl'
import meterEchart from "./meterEchart";
export default {
  name: "left-progress",
  components: {
    meterEchart,
  },
  data() {
    return {
      yrfdFdl:"",
      yrfdDFdl:"",
      snSlYlData:{
        SLM:{},
        SNM:{},
        Y:{}
      },
      strokeColor: {
        "0%": "#101BFF",
        "100%": "#2BB3FF",
      },
      timeOut:null,
      NHData:{
        zhmh:null,
        swmh:null,
        bzmh:null,
      }
    };
  },
  created() {
    
  },
  mounted() {
    let _this =this
    _this.getGXByHour()
    _this.getYrfd()
    _this.getNhsj()
    _this.timeOut = setInterval(function () {
      _this.getGXByHour()
      _this.getYrfd()
      _this.getNhsj()
    }, 1800000);
  },
  destroyed(){
    if (this.timeOut) {
      clearTimeout(this.timeOut)
    }
  },
  methods: {
    getGXByHour(){
      this.$myHttp.get(httpUrl.home.getGXByHour).then(res => {
          this.snSlYlData.SLM=res.data.SLM
          this.snSlYlData.SNM=res.data.SNM
          this.snSlYlData.Y=res.data.Y
      }).catch(res => {})
    },
    //余热发电
    getYrfd(){
      this.$myHttp.get(httpUrl.home.yurefadian).then(res => {
      }).catch(res => {
        this.yrfdFdl = res.data[2].day
        this.yrfdDFdl=res.data[1].day
      })
    },
    //能耗数据
    getNhsj(){
      this.$myHttp.get(httpUrl.home.meihaohao).then(res => {
      }).catch(res => {
        this.getDH();
        this.NHData.swmh=res.data[0].day;
        this.NHData.bzmh=res.data[1].day;
      })
    },
    //电耗
    getDH(){
      this.$myHttp.get(httpUrl.home.dianhao).then(res => {
      }).catch(res => {
        let num= Number(res.data[2].day)*1.229+Number(this.NHData.bzmh)
        this.NHData.zhmh= num.toFixed(2);
      })
    },
  },
};
</script>

<style scoped>
.center-panel {
  font-size: 16px;
  position: relative;
}

.step-1,
.step-2,
.step-3 {
  display: flex;
  height: 75%;
  margin-top: 26px;
}

.left-top-content {
  position: absolute;
  top: -29%;
  right: -15%;
  transform: translate(-50%);
}

.left-top-exral {
  position: absolute;
  top: -6%;
  left: 20%;
  transform: translate(-50%);
}

.left-bottom-content-1 {
  display: flex;
  margin-top: 25px;
  height: 70%;
}

.left-bottom-part-2 {
  position: absolute;
  top: 105%;
  left: 18%;
  transform: translate(-50%);
}

.left-center-content {
  position: absolute;
  top: 25%;
  left: 82%;
  transform: translate(-50%);
}

.right-bottom-content {
  position: absolute;
  top: 62%;
  left: 85%;
  transform: translate(-50%);
}

.center-panel /deep/ .ant-progress-text {
  color: #fff !important;
  font-weight: bold;
  font-size: 1.6rem;
}

.ant-progress-circle-trail {
  stroke: #344890 !important;
}

.left-top-content {
  width: 380px;
  height: 180px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: url("../../../assets/picture/center/3x.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;
}

.left-top-exral {
  width: 320px;
  height: 196px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: url("../../../assets/picture/center/energy_count.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;
}

.left-center-content {
  width: 380px;
  height: 180px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: url("../../../assets/picture/center/3x.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;
}

.text-count {
  display: flex;
  width: 100px;
  justify-content: space-around;
  background: rgb(51, 108, 222, 0.4);
  border-left: 2px #1fedff solid;
}

.text-number,
.text-number-1 {
  font-size: 1.8rem;
  font-weight: bold;
}
.text-unit {
  font-size: 13px;
  margin-top: -30px;
  font-weight: bold;
}

.left-bottom-part-2 {
  width: 380px;
  height: 180px;
  display: flex;
  position: relative;
  justify-content: center;
  background: url("../../../assets/picture/center/3x.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;
  flex-direction: column;
}

.right-top-content {
  width: 250px;
  height: 120px;
  display: flex;
  position: relative;
  justify-content: center;
  background: url("../../../assets/picture/center/process_box.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;
  flex-direction: column;
}

.right-bottom-content {
  width: 320px;
  height: 170px;
  display: flex;
  position: relative;
  justify-content: center;
  background: url("../../../assets/picture/center/process_box.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;
  flex-direction: column;
}
.progress-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  justify-content: space-around;
}

.text-wrap {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 24px;
  height: 90px;
}

.text-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  height: 100%;
}

.title-pos-1 {
  position: absolute;
  top: 10px;
  right: 6px;
}

.title-pos-2 {
  position: absolute;
  top: 10px;
  right: 20px;
}

.title-pos-3 {
  position: absolute;
  top: 8px;
  left: 10px;
}

.title-pos-4 {
  position: absolute;
  top: 25px;
  left: 10px;
}

.row-2 {
  margin: 0 13px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/home/centerTop/centerPanel.vue